import type { AsrModelHealth } from '../../api/types';

type TProps = {
  health?: AsrModelHealth;
};

const dotBaseClassName = 'inline-block h-2.5 w-2.5 rounded-full align-middle';

export const HealthDot = ({ health }: TProps) => {
  if (!health) {
    return (
      <span
        className={`${dotBaseClassName} animate-pulse bg-[var(--color-warning-text)]`}
        title="checking…"
        aria-label="loading"
      />
    );
  }

  const checkedAtLabel = health.checkedAt ? ` · ${new Date(health.checkedAt).toLocaleTimeString()}` : '';
  const title = `${health.detail ?? (health.ok ? 'healthy' : 'down')}${checkedAtLabel}`;

  return (
    <span
      className={`${dotBaseClassName} ${health.ok ? 'bg-[var(--color-green)]' : 'bg-[var(--color-danger)]'}`}
      title={title}
      aria-label={health.ok ? 'ok' : 'down'}
    />
  );
};
